import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/dpa/*.md"))

export const Route = createFileRoute("/_content/dpa/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Data Processing Agreement (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Data Processing Agreement from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/dpa/${loaderData.date}`,
      image: "https://entire.com/og/page/dpa.png",
      noindex: true,
    })
  },
  component: DpaVersionPage,
})

function DpaVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/dpa" version={version} versions={versions} />
}
